import styled from "styled-components";

export const JackpotToastClockDefaultBox = styled.div`
    font-size: 2.8rem;
    text-align: center;
    background-color: ${props => props.theme.colors.backgroundLight};
    margin: 0 0 0 1rem;
    padding: 0.4rem 1.6rem 0.3rem 1.5rem;
    min-width: 10rem;
    border-radius: 1rem;
    font-family: ${({theme}) => theme.components.jackpotWidget.font.clock};
    line-height: 1;
    
    @media ${props => props.theme.mediaQuery.mAndBelow} {
        font-size: 2.2rem;
        padding: 0.2rem 1rem 0.1rem 1rem;
        margin: 0 0 0 0.6rem;
        border-radius: 0.6rem;
    }
`;